export default function IconGift({
  width = 24,
  height = 25,
}: {
  readonly width?: number
  readonly height?: number
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
    >
      <rect width="24" height="24" transform="translate(0 0.5)" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.06947 3.26978C8.55933 1.77993 11.2689 2.42328 11.8245 4.50686L11.8262 4.51332L11.9998 5.18855L12.1751 4.50685C12.7307 2.42328 15.4403 1.77993 16.9301 3.26978L16.9417 3.2813L16.9527 3.29331C18.0982 4.54293 17.9537 6.44261 16.7904 7.45011H20.2998C20.7702 7.45011 21.2206 7.61019 21.5551 7.94478C21.8897 8.27936 22.0498 8.72967 22.0498 9.20011V12.4501H19.9498V20.7001C19.9498 21.1705 19.7897 21.6209 19.4551 21.9554C19.1206 22.29 18.6702 22.4501 18.1998 22.4501H5.7998C4.73769 22.4501 4.0498 21.5647 4.0498 20.7001V12.4501H2.0498V9.20011C2.0498 8.72967 2.20989 8.27936 2.54447 7.94478C2.87906 7.61019 3.32937 7.45011 3.7998 7.45011H7.20919C6.04592 6.44261 5.90146 4.54293 7.04694 3.29331L7.05795 3.2813L7.06947 3.26978ZM11.2498 8.95011H3.7998C3.67024 8.95011 3.62055 8.99002 3.60513 9.00544C3.58972 9.02085 3.5498 9.07054 3.5498 9.20011V10.9501H11.2498V8.95011ZM11.2498 12.4501H5.5498V20.7001C5.5498 20.7548 5.57399 20.8233 5.6231 20.8759C5.66519 20.921 5.72044 20.9501 5.7998 20.9501H11.2498V12.4501ZM12.7498 20.9501V12.4501H18.4498V20.7001C18.4498 20.8297 18.4099 20.8794 18.3945 20.8948C18.3791 20.9102 18.3294 20.9501 18.1998 20.9501H12.7498ZM12.7498 10.9501V8.95011H20.2998C20.4294 8.95011 20.4791 8.99002 20.4945 9.00544C20.5099 9.02085 20.5498 9.07054 20.5498 9.20011V10.9501H12.7498ZM13.0423 7.15765L15.3094 6.57467C16.2024 6.33424 16.6016 5.14632 15.8581 4.31924C15.1464 3.6248 13.8702 3.98104 13.6252 4.89051L13.0423 7.15765ZM10.9573 7.15765L10.3744 4.89051C10.1294 3.98103 8.85318 3.6248 8.14146 4.31925C7.39805 5.14633 7.79723 6.33424 8.6902 6.57467L10.9573 7.15765Z"
        fill="#101010"
      />
    </svg>
  )
}
